import React from "react";
import "./Footer.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Função para navegação suave
  const handleNavigation = (path, anchor = null) => {
    if (anchor && location.pathname === path) {
      scrollToAnchor(anchor);
    } else if (anchor) {
      localStorage.setItem("scrollToAnchor", anchor);
      window.location.href = path;
    } else {
      window.location.href = path;
    }
  };

  const scrollToAnchor = (anchor) => {
    const element = document.getElementById(anchor);
    if (element) {
      const offsetTop = element.offsetTop - 100; // Ajuste para altura da navbar
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };
  const handleLogoClick = () => {
    if (location.pathname === "/") {
      const banner = document.getElementById("banner-home");
      if (banner) {
        window.scrollTo({
          top: banner.offsetTop - 80,
          behavior: "smooth",
        });
      }
    } else {
      window.location.href = "/";
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          {/* Logo e Descrição */}
          <div
            className="footer-brand"
            style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}
          >
            <div
              className="footer-logo"
              style={{ marginBottom: 0, cursor: "pointer" }}
              onClick={handleLogoClick}
            >
              <img src="/assets/img/logo.png" alt="Dsiacdata" />
            </div>
            <p
              className="footer-description"
              style={{ marginBottom: 0, textAlign: "left" }}
            >
              {t("footer.description")}
            </p>
          </div>

          {/* Produtos */}
          <div className="footer-section">
            <h3 className="footer-title">{t("footer.products.title")}</h3>
            <ul className="footer-links">
              {" "}
              <li>
                <a
                  className="footer-link-btn"
                  href="/reproducao-humana-assistida"
                >
                  {t("footer.products.platform2")}
                </a>
              </li>
              <li>
                <a
                  className="footer-link-btn"
                  href="/cuidados-saude-atencao-primaria"
                >
                  {t("footer.products.platform1")}
                </a>
              </li>
            </ul>
          </div>

          {/* Empresa */}
          <div className="footer-section">
            <h3 className="footer-title">{t("footer.about.title")}</h3>
            <ul className="footer-links">
              <li>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNavigation("/sobre", "banner-sobre")}
                >
                  {t("footer.about.aboutDsiacdata")}
                </button>
              </li>
              <li>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNavigation("/sobre", "nossa-missao")}
                >
                  {t("footer.about.mission")}
                </button>
              </li>
              <li>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNavigation("/sobre", "nossa-historia")}
                >
                  {t("footer.about.history")}
                </button>
              </li>
              <li>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNavigation("/sobre", "nossos-parceiros")}
                >
                  {t("footer.about.partners")}
                </button>
              </li>
            </ul>
          </div>

          {/* Recursos */}
          <div className="footer-section">
            <h3 className="footer-title">{t("footer.resources.title")}</h3>
            <ul className="footer-links">
              <li>
                <button
                  className="footer-link-btn"
                  onClick={() =>
                    handleNavigation("/recursos", "banner-recursos")
                  }
                >
                  {t("footer.resources.resourceCenter")}
                </button>
              </li>
              <li>
                <button
                  className="footer-link-btn"
                  onClick={() =>
                    handleNavigation("/recursos", "recursos-principais")
                  }
                >
                  {t("footer.resources.news")}
                </button>
              </li>
              <li>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNavigation("/recursos", "faq-section")}
                >
                  {t("footer.resources.faq")}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="footer-copyright">
            <p>
              {t("footer.copyright")} <span style={{ margin: "0 8px" }}>|</span>
              <a
                href="https://nexus-technologies.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#7dd3c0",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                {t("footer.developedBy")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
